<template lang="pug">
    .col-span-6
        label.block.text-sm.font-medium.text-gray-700(
            :class="{ 'required': parameter['required'] }")
            | {{ parameter.name }}
        .radio__container(:class="{ 'form-error': error }")
            .flex.radio__wrapper(
                :id="'field_' + parameter.id"
                v-for="radio in radios"
            )
                input.radio__input(type="radio"
                    :id="'field_' + radio.id"
                    :value='radio.id'
                    v-model='selected')
                label.radio__label.font-medium.text-gray-700(:for="'field_' + radio.id")
                    | {{ radio.name }}
        p.mt-2.p-1.rounded.text-sm.text-red-500.bg-gray-100(v-if='error')
            | {{ error.message || 'Поле обязательно для заполнения' }}

</template>

<script>
import store from 'js@/store'

export default {

    name: 'ItemFormGroupParameterRadio',

    store,

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: String,
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data() {
        return {
            radios: {},
            selected: this.value,
        }
    },

    // todo: can be taken out (computed and mounted according extra field) of all similar components into a separate file
    computed: {
        extra() {
            return this.parameter.hasOwnProperty('extra_serialized') ?
                this.parameter.extra_serialized :
                [{id: 0, name: 'Нет'}]
        }
    },

    watch: {
        selected(value) {
            this.$emit('input', value)
        },
    },

    mounted() {
        if (this.extra) {
            // this.radios = (typeof this.extra === "string") ? JSON.parse(this.extra) : this.extra
            this.radios =  this.extra
            this.selected = this.radios[0].id
        }
    },

}

</script>

<style lang="sass">
.radio__container
    border-radius: 0.375rem
    padding: 5px
    .radio__wrapper
        flex-direction: row
        .radio__label
            padding: 0 7px
        .radio__input
            align-self: center
</style>
